<template>
  <CRow>
    <CCol col="12" sm="6" lg="4" style="margin-top: auto">
      <CWidgetIcon
        :header="this.totalToken"
        text="All token"
        color="gradient-primary"
        :icon-padding="false"
        link="#"
      >
        <CIcon name="cil-laptop" class="mx-3" width="24" />
      </CWidgetIcon>
    </CCol>
    <CCol col="12" sm="6" lg="4" style="margin-top: auto">
      <CWidgetIcon
        :header="this.totalUser"
        text="Total user"
        color="gradient-info"
        :icon-padding="false"
        link="#"
      >
        <CIcon name="cil-user" class="mx-3" width="24" />
      </CWidgetIcon>
    </CCol>
    <CCol col="12" sm="6" lg="4">
      <CSelect
        horizontal
        :options="options"
        placeholder="select token"
        :value.sync="fielterdata"
        @change="onChange($event)"
        style="width: 64%; "
      />
        
      <CWidgetIcon
        :header="this.available + ' Available Token'"
        :text="this.totalSupply + ' Total Token'"
        color="gradient-warning"
        :icon-padding="false"
        link="#"
      >
        <CIcon name="cil-cursor" class="mx-3" width="24" />
      </CWidgetIcon>
    </CCol>
  </CRow>
</template>

<script>
import { CChartLineSimple, CChartBarSimple } from "../charts/index.js";
import firebase from "firebase";
const db = firebase.firestore();
export default {
  name: "WidgetsDropdown",
  components: { CChartLineSimple, CChartBarSimple },
  data() {
    return {
      fielterdata: "",
      tableData: [],
      tableToken: [],
      tokenLength: "",
      totalToken: "",
      userLength: "",
      totalUser: "",
      available: "",
      totalSupply: "",
      options: [],
      tokenBal: [],
      // selected:"All"
    };
  },
  methods: {
    assignsmallData(doc) {
      let smallDocument = {
        id: doc.id,
        name: doc.data().name,
        symbol: doc.data().symbol,
        totalSupply: doc.data().totalSupply,
        companyName: doc.data().companyName,
        description: doc.data().description,
        country: doc.data().country,
        ethereum: doc.data().ethAddress,
        contract: doc.data().conAddress,
        location: doc.data().location,
        logo: doc.data().logo,
      };
      return smallDocument;
    },
    assigntokenData(doc) {
      let smallDocument = {
        id: doc.id,
        name: doc.data().name,
        symbol: doc.data().symbol,
        totalSupply: doc.data().totalSupply,
        availableSupply: doc.data().availableSupply,
        companyName: doc.data().companyName,
        description: doc.data().description,
        country: doc.data().country,
        ethereum: doc.data().ethAddress,
        contract: doc.data().conAddress,
        location: doc.data().location,
        logo: doc.data().logo,
      };
      return smallDocument;
    },
    getusers() {
      this.tableData = [];
      const db = firebase.firestore();
      db.collection("users")
        .get()
        .then((querySnapshot) => {
          // snapshot.forEach((doc) => {
             console.log("snapshot.doc.size",querySnapshot.size); 
             this.totalUser = querySnapshot.size
            // this.tableData.push(this.assignsmallData(doc));

            // this.userLength = this.tableData.length;

            // this.totalUser = this.userLength.toString();

            // console.log("totalUser",typeof(this.totalUser) )
          // });
          this.loading = false;
        });
    },
    gettokens() {
      this.tableData = [];
      const db = firebase.firestore();
      db.collection("companyDetails2")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.tableToken.push(this.assigntokenData(doc));
            this.tokenLength = this.tableToken.length;
            this.totalToken = this.tokenLength.toString();
            let value = this.tableToken.map((n) => {
              return n.name;
            });

            this.options = value;
          });
        });
    },
    onChange(event) {
       console.log("datasend",event.target.value)
       this.$root.$emit("datasent",event.target.value)
      
      this.tokenBal = [];
     
      db.collection("companyDetails2")
        .where("name", "==", event.target.value)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.tokenBal.push(this.assigntokenData(doc));

            let value = this.tokenBal.map((n) => {
              return n.totalSupply;
            });
            let value1 = this.tokenBal.map((n) => {
              return n.availableSupply;
            });

            this.totalSupply = value.toString();
            this.available = value1.toString();
            
          });
          this.loading = false;
        });
    },
  },
  created() {
    this.getusers();
    this.gettokens();
    this.onChange();
  },
};
</script>
